module.exports = __webpack_public_path__ + "img/start.c4227ac7.svg";